export default "__VITE_ASSET__DhoZSyM0__"